import BrandContextForm from '../components/BrandContextForm';

const BrandContextPage = () => {
  return <BrandContextForm />;
};

export default BrandContextPage;
